import React, { useEffect, useState } from 'react';
import { IonHeader, IonIcon, IonGrid, IonRow, IonCol, IonModal, IonContent, IonRefresher, IonRefresherContent, IonAlert } from '@ionic/react';
import './MopHeaderMenusModal.scss';
import { warningOutline, documentTextOutline, personCircle, chevronBack } from 'ionicons/icons';
import { useSelector, useDispatch } from 'react-redux';
import '../theme/common.scss';
import * as headerFooterStore from '../store/HeaderFooterStore';
import TermsCondModal from '../modals/TermsCondModal';
import AllergenModal from '../modals/AllergenModal';
import LoginModal from '../modals/LoginModal';
import { ApplicationState } from '../store';
import { bindActionCreators } from 'redux';
import { baseUrl } from '../helpers/configHelper';
import moment from 'moment';
import * as currencyHelpers from '../helpers/currencyHelpers';
import * as ColleaguesStore from '../store/ColleagueStore';
import { downloadAllergenFile } from '../helpers/menuHelpers';

interface MopOrderStatus {
    mopOrderUid: string;
    customerOrderNumber: string;
    status: string;
    orderPlaced: string | Date;
    completed: boolean;
    orderTotal: number;
    orderStoreLocation: string;
}

const MopHeaderMenusModal: React.FC<{ isModalOpen: boolean, closeModalClick: any }> = ({ isModalOpen, closeModalClick }) => {

    const headerFooter = useSelector((state: ApplicationState) => state.headerFooter);
    const boundSetShowModal = bindActionCreators(headerFooterStore.actionCreators.setShowModal, useDispatch());
    const [orders, setOrders] = useState<MopOrderStatus[]>([]);
    const [showLogoutAlert, setShowLogoutAlert] = useState(false);
    const setIsLoggedIn = bindActionCreators(ColleaguesStore.actionCreators.logout, useDispatch());
    const isLoggedIn = useSelector((state: ApplicationState) => state.colleague?.isLoggedIn);

    const getOrderStatus = (event?: CustomEvent) => {
        const test = false;
        const orderGUIDs: string[] = test ? ["049767f4-fa3c-4462-b3be-7f28a6603d24", "049767f4-fa3c-4462-b3be-7f28a6603d24", "049767f4-fa3c-4462-b3be-7f28a6603d24"] : JSON.parse(localStorage.getItem("mopOrders") || '[]');
        if (orderGUIDs.length > 0) {
            fetch(`${baseUrl()}/orders/GetOrderStatus`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(orderGUIDs)
            })
                .then(res => res.json() as Promise<MopOrderStatus[]>)
                .then(res => {
                    setOrders(res.map(order => ({ ...order, orderPlaced: moment(order.orderPlaced).format("Do MMMM YYYY") })));
                })
                .finally(() => {
                    if (event != undefined) {
                        event.detail.complete();
                    }
                })
        } else {
            if (event != undefined) {
                event.detail.complete();
            }
        }
    }

    useEffect(() => {
        getOrderStatus();
    }, []);

    const handleLogout = () => {
        setShowLogoutAlert(true);
    };

    const handleLogoutConfirmation = (confirmed: boolean) => {
        if (confirmed) {
            setIsLoggedIn(false)
            localStorage.removeItem('isLoggedIn')
            localStorage.removeItem("pfidentifier");
            window.location.reload();
        }
        setShowLogoutAlert(false);
    };

    return (
        <>
            <IonModal isOpen={isModalOpen}
                onWillPresent={() => {
                    getOrderStatus();
                }}
                onDidDismiss={closeModalClick}
                cssClass='AppHeaderBurgerMenu'
                swipeToClose={true}
                id="MainModal">
                <IonHeader className="ion-no-border modal-header" mode="md" onClick={closeModalClick}>
                    <div className="BackArrowWrapper">
                        <IonIcon icon={chevronBack} slot={"start"} class="BackArrow"></IonIcon>
                    </div>
                </IonHeader>
                <IonContent>
                    <div className="AppHeaderMenuTitle">Recent Orders</div>
                    <IonRefresher slot="fixed" onIonRefresh={getOrderStatus}>
                        <IonRefresherContent/>
                    </IonRefresher>
                    <div className="YourOrdersInner">

                        <IonGrid>
                            {
                                orders.length > 0
                                    ?
                                    <>
                                        <div>
                                            {
                                                orders.map(order => <IonRow key={order.mopOrderUid} className="yourOrdersItem">
                                                    <IonCol size="9" className="yourOrdersLeft">
                                                        <div className="yourOrdersItemTitle">{order.orderPlaced}</div>
                                                        <div className="yourOrdersItemDetail">{order.orderStoreLocation}</div>
                                                        {
                                                            !order.completed &&
                                                            <>
                                                                <div className="yourOrdersItemDetail"><span style={{ color: 'var(--ion-color-primary)' }}>Status:</span> {order.status}</div>
                                                                <div className="yourOrdersItemDetail"><span style={{ color: 'var(--ion-color-primary)' }}>Order Number:</span> {order.customerOrderNumber}</div>
                                                            </>
                                                        }
                                                    </IonCol>
                                                    <IonCol size="3" className="yourOrdersRight">
                                                        <div className="yourOrdersItemTitle" style={{ color: 'var(--ion-color-primary)' }}>{currencyHelpers.formatCurrency(order.orderTotal)}</div>
                                                    </IonCol>
                                                </IonRow>)
                                            }
                                        </div>
                                    </>
                                    :
                                    <IonRow className="yourOrdersItem">
                                        <IonCol size="12">
                                            <h4>We can't find any recent orders that have been placed on this device</h4>
                                        </IonCol>
                                    </IonRow>
                            }
                        </IonGrid>

                    </div>

                    <div className="AppHeaderMenuTitle">Product Information</div>
                    <div
                        className="AppHeaderMenuLink"
                        onClick={downloadAllergenFile}>
                        <IonIcon icon={warningOutline} />
                        <div className="AppHeaderMenuLinkInner">
                                Allergen Information
                        </div>
                    </div>

                    <div className="AppHeaderMenuTitle">Legal</div>
                    <div className="AppHeaderMenuLink" onClick={() => boundSetShowModal("TC", true)}><IonIcon icon={documentTextOutline}></IonIcon><div className="AppHeaderMenuLinkInner">Terms & Conditions</div> </div>
                    <div className="AppHeaderMenuTitle">Colleague Area Access</div>
                    <div className="AppHeaderMenuLink" onClick={() => { localStorage.getItem('isLoggedIn') === "true" ? handleLogout() : boundSetShowModal("LOGIN", true) }}><IonIcon icon={personCircle}></IonIcon><div className="AppHeaderMenuLinkInner">{localStorage.getItem('isLoggedIn') === "true" ? "Log out" : "Log in"}</div> </div>

                </IonContent>
                <TermsCondModal isModalOpen={headerFooter?.modals.selectedModal === "TC"} closeModalClick={() => { boundSetShowModal("TC", false); }}></TermsCondModal>
                <AllergenModal isModalOpen={headerFooter?.modals.selectedModal === "ALLERGEN"} closeModalClick={() => boundSetShowModal("ALLERGEN", false)}></AllergenModal>
                <LoginModal isModalOpen={headerFooter?.modals.selectedModal === "LOGIN"} parentModalClick={closeModalClick} closeModalClick={() => boundSetShowModal("LOGIN", false, true)}></LoginModal>

            </IonModal>
            <IonAlert
                isOpen={showLogoutAlert}
                header="Are you sure you want to log out of Colleague Area Access?"
                buttons={[
                    {
                        text: 'No',
                        role: 'cancel',
                        handler: () => handleLogoutConfirmation(false),
                    },
                    {
                        text: 'Yes',
                        handler: () => handleLogoutConfirmation(true),
                    },
                ]}
            />
        </>

    );
};

export default MopHeaderMenusModal;
